import { render, staticRenderFns } from "./ShowCollegeDetail.vue?vue&type=template&id=d3597b94&scoped=true"
import script from "./ShowCollegeDetail.vue?vue&type=script&lang=ts"
export * from "./ShowCollegeDetail.vue?vue&type=script&lang=ts"
import style0 from "./ShowCollegeDetail.vue?vue&type=style&index=0&id=d3597b94&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3597b94",
  null
  
)

export default component.exports